var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 592,
    viewBox: "0 0 275 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 658C250.5 452 28 463.268 28 277.5C28 19.8929 35 13.5 -46.5 13.5",
    stroke: "#F9E9E2",
    strokeWidth: 26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M262 663.5C262 423.5 41.4999 450.5 41.4999 288.5C41.4999 126.5 78.5 23.5001 -23.5 23.5001",
    stroke: "white",
    strokeWidth: 26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcon6);
export default __webpack_public_path__ + "static/media/onboarding-icon6.6d15bf33e9d6d193861a87e17208f537.svg";
export { ForwardRef as ReactComponent };